import ChevronLeftIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightIcon from "@mui/icons-material/ChevronRightRounded";
import { styled } from "@mui/material";
import { useSliderPreview } from "components/swiper";
import * as React from "react";
import { Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import ProductCard from "./ProductCard";

const defaultMatchMap = {
  xs: "auto" as const,
  sm: "auto" as const,
  md: 2,
  lg: 2,
  xl: 2,
};

export const Button = styled("button")(({ theme }) => ({
  width: 56,
  height: 56,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  // borderRadius: "100%",
  // boxShadow: theme.shadows[8],
  border: 0,
  position: "absolute",
  top: "calc(50% - 28px)",
  zIndex: 2,
  cursor: "pointer",
  background: "transparent",
  // background: "#ffffff",
  "&:disabled": {
    color: theme.palette.grey[300],
  },
}));

const SlideButtonPrev = () => {
  const swiper = useSwiper();
  const [disabled, setDisabled] = React.useState(swiper.isBeginning);

  swiper.on("activeIndexChange", function (e) {
    setDisabled(e.isBeginning);
  });

  const onClick = () => {
    swiper && swiper.slidePrev();
  };

  return (
    <Button
      sx={{ left: 24 }}
      onClick={onClick}
      disabled={disabled}
      aria-label="Previous product"
    >
      <ChevronLeftIcon sx={{ fontSize: 40 }} />
    </Button>
  );
};

const SlideButtonNext = () => {
  const swiper = useSwiper();
  const [disabled, setDisabled] = React.useState(swiper.isBeginning);

  swiper.on("activeIndexChange", function (e) {
    setDisabled(e.isBeginning);
  });

  const onClick = () => {
    swiper && swiper.slideNext();
  };

  return (
    <Button
      sx={{ right: 24 }}
      onClick={onClick}
      disabled={disabled}
      aria-label="Next product"
    >
      <ChevronRightIcon sx={{ fontSize: 40 }} />
    </Button>
  );
};

export default function ProductSwiper({
  ids,
  matchMap = defaultMatchMap,
}): React.ReactElement {
  const { slidesPerView, sm: matchesXS } = useSliderPreview(matchMap);

  return (
    <Swiper
      loop={true}
      modules={[Autoplay]}
      slidesPerView={slidesPerView}
      spaceBetween={16}
      autoplay={true}
      style={{ position: "relative", padding: "16px", margin: "-16px" }}
    >
      {ids?.map((item) => (
        <SwiperSlide
          key={item.id}
          style={{
            width: matchesXS ? "80%" : "auto",
          }}
        >
          <ProductCard id={item} />
        </SwiperSlide>
      ))}
      <SlideButtonPrev />
      <SlideButtonNext />
    </Swiper>
  );
}
